/* ============================================================
   ALIVE — tema-JS (v2)
   Samme adfærd som den statiske side, men alt er null-sikret,
   så sektioner kan slås fra eller flyttes i temaeditoren uden
   at siden brækker.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── SCROLL PROGRESS ───────────────────────────────────── */
  var prog = $('#progress');
  if (prog) {
    window.addEventListener('scroll', function () {
      var h = document.body.scrollHeight - window.innerHeight;
      prog.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    }, { passive: true });
  }

  /* ── STICKY CTA ────────────────────────────────────────── */
  var stickyCta = $('#sticky-cta');
  var hero = $('#hero');
  if (stickyCta && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      stickyCta.classList.toggle('show', !e[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  } else if (stickyCta && !hero) {
    stickyCta.classList.add('show');
  }

  /* ── SCROLL REVEAL ─────────────────────────────────────── */
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('v');
        io.unobserve(e.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px 280px 0px' });
    $$('.r,.rx,.rxr,.rs,.ln').forEach(function (el) { io.observe(el); });

    var stagIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('v');
        stagIo.unobserve(e.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px 140px 0px' });
    $$('[data-stag]').forEach(function (el) { stagIo.observe(el); });
  } else {
    $$('.r,.rx,.rxr,.rs,.ln,[data-stag]').forEach(function (el) { el.classList.add('v'); });
  }

  /* ── MAGNETISKE KNAPPER ────────────────────────────────── */
  if (!reduced) {
    $$('.magnetic').forEach(function (el) {
      var rafId, tx = 0, ty = 0;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        tx = (e.clientX - (r.left + r.width / 2)) * 0.18;
        ty = (e.clientY - (r.top + r.height / 2)) * 0.18;
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          el.style.transition = 'transform .1s linear, background .22s, box-shadow .22s';
          el.style.transform = 'translate(' + tx + 'px,' + ty + 'px)';
        });
      });
      el.addEventListener('mouseleave', function () {
        cancelAnimationFrame(rafId);
        el.style.transition = 'transform .5s cubic-bezier(.22,1,.36,1), background .22s, box-shadow .22s';
        el.style.transform = 'translate(0,0)';
      });
    });
  }

  /* ── HERO: 3D-tilt + parallax ──────────────────────────── */
  var dockEl = $('#dock');
  if (dockEl && hero && !reduced) {
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - 0.5) * 10;
      var y = ((e.clientY - r.top) / r.height - 0.5) * -7;
      dockEl.style.transition = 'transform .15s linear';
      dockEl.style.transform = 'perspective(800px) rotateY(' + x + 'deg) rotateX(' + y + 'deg)';
    });
    hero.addEventListener('mouseleave', function () {
      dockEl.style.transition = 'transform .8s cubic-bezier(.22,1,.36,1)';
      dockEl.style.transform = 'perspective(800px) rotateY(0deg) rotateX(0deg)';
    });
  }

  var heroProduct = $('#hero-prod');
  if (heroProduct && !reduced) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < window.innerHeight) heroProduct.style.transform = 'translateY(' + (y * 0.12) + 'px)';
    }, { passive: true });
  }

  /* ── NAV: flyder rent (blød skygge) når man scroller ───── */
  var navEl = $('#nav');
  if (navEl) {
    window.addEventListener('scroll', function () {
      navEl.classList.toggle('stuck', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── MOBILMENU ─────────────────────────────────────────── */
  var burger = $('#navBurger');
  var mobileMenu = $('#navMobile');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('a', mobileMenu).forEach(function (a) {
      a.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── FAQ-harmonika ─────────────────────────────────────── */
  window.faq = function (btn) {
    var item = btn.parentElement;
    var open = item.classList.contains('open');
    $$('.faq-item.open').forEach(function (el) {
      el.classList.remove('open');
      var i = el.querySelector('.faq-icon'); if (i) i.textContent = '+';
    });
    if (!open) item.classList.add('open');
  };

  window.toggleModels = function (btn) {
    var list = btn.nextElementSibling;
    if (!list) return;
    var open = list.classList.toggle('open');
    btn.classList.toggle('open', open);
    btn.lastChild.textContent = open ? ' Skjul modeller' : ' Vis alle kompatible modeller';
  };

  /* ── APP-BLOKERING: klikbare app-fliser ────────────────── */
  window.pustToggleApp = function (b) {
    b.classList.toggle('locked');
    var locked = b.classList.contains('locked');
    b.setAttribute('aria-pressed', locked);
    b.setAttribute('aria-label', b.dataset.app + (locked ? ' — låst' : ' — ulåst'));
  };

  /* ── TÆLLER: "+5½ time" ────────────────────────────────── */
  var gain = $('#gainCount');
  if (gain && !reduced && 'IntersectionObserver' in window) {
    var end = parseInt(gain.getAttribute('data-to') || '5', 10);
    var io2 = new IntersectionObserver(function (e) {
      if (!e[0].isIntersecting) return;
      io2.disconnect();
      var v = 0;
      var step = function () { v++; gain.textContent = v; if (v < end) setTimeout(step, 120); };
      gain.textContent = '0';
      setTimeout(step, 150);
    }, { threshold: 0.4 });
    io2.observe(gain);
  }

  /* ── PRODUKT: farvevælger ──────────────────────────────── */
  /* Alle seks farver kan vælges — brikken i heroen skifter farve, så hun
     får set dem. De fem er udsolgt: de bærer et skråstreg-mærke, og
     købsknappen låser med en vej tilbage til Stone. Låsen er ikke pynt.
     Farverne er ikke Shopify-varianter, så uden den ville et klik på
     ”Køb nu” efter Graphite udlevere en Stone. */
  function farveSoldOut(sold, name, label) {
    var note = $('#fpNote');
    if (note) {
      note.hidden = !sold;
      if (sold) { var n = $('#fpNoteName'); if (n) n.textContent = name; }
    }
    /* Knappen siger kun ”Udsolgt”. Farvenavnet står allerede tre linjer
       oppe i vælgeren og i noten — at gentage det gør knappen lang uden
       at sige mere. */
    var buttons = [
      { el: $('#pustBuyForm .wl-submit'), text: label },
      { el: $('#pustStickyBuy .psb-btn'), text: label }
    ];
    buttons.forEach(function (b) {
      if (!b.el) return;
      if (sold) {
        /* Husk om knappen ALLEREDE var slået fra (produktet selv udsolgt),
           så vi ikke låser den op igen på vej tilbage til Stone. */
        if (!b.el.hasAttribute('data-was-off')) {
          b.el.setAttribute('data-was-off', b.el.disabled ? '1' : '0');
        }
        b.el.setAttribute('data-sold-label', b.text);
        b.el.classList.add('is-sold');
        b.el.disabled = true;
      } else {
        b.el.classList.remove('is-sold');
        b.el.removeAttribute('data-sold-label');
        b.el.disabled = b.el.getAttribute('data-was-off') === '1';
        b.el.removeAttribute('data-was-off');
      }
    });
  }

  window.pickFarve = function (btn) {
    if (!btn) return;
    var wrap = btn.parentNode && btn.parentNode.parentNode;
    var label = (wrap && wrap.getAttribute && wrap.getAttribute('data-soldout-label')) || 'Udsolgt';
    var sold = btn.hasAttribute('data-soldout');
    var name = btn.getAttribute('data-name') || '';
    $$('.fp-sw').forEach(function (s) { s.classList.remove('active'); s.setAttribute('aria-pressed', 'false'); });
    btn.classList.add('active');
    btn.setAttribute('aria-pressed', 'true');
    var val = $('#fpVal'); if (val) val.textContent = sold ? name + ' — ' + label : name;
    var cap = $('#heroCap');
    if (cap && btn.getAttribute('data-cap')) cap.textContent = btn.getAttribute('data-cap');
    var puck = $('#heroPuck');
    if (puck && btn.getAttribute('data-color')) {
      puck.style.background = btn.getAttribute('data-color');
      puck.classList.add('pop');
      setTimeout(function () { puck.classList.remove('pop'); }, 280);
    }
    var base = $('#basePuck');
    if (base && btn.getAttribute('data-base')) base.style.background = btn.getAttribute('data-base');

    /* Findes der rigtige fotos, ligger brikken i sin egen visning: en udsolgt
       farve åbner den, Stone lukker den og giver fotoet tilbage. Uden fotos
       ER brikken galleriet, og så er der intet at skifte imellem. */
    var farve = $('.ph-farve');
    if (farve) {
      if (sold && btn.getAttribute('data-color')) {
        $$('.ph-view').forEach(function (v) { v.classList.remove('a'); });
        farve.classList.add('a');
      } else {
        window.phGo(0);
      }
    }
    farveSoldOut(sold, name, label);
  };

  /* ── PRODUKT: billedgalleri ────────────────────────────── */
  window.phCur = 0;
  window.phGo = function (i) {
    /* .ph-farve er farvevælgerens egen visning og hører ikke med i
       gennemløbet — ellers ville pilene og prikkerne føre ind i den. */
    var views = $$('.ph-view:not(.ph-farve)');
    var dots = $$('.ph-dot');
    if (!views.length) return;
    var farve = $('.ph-farve'); if (farve) farve.classList.remove('a');
    var n = views.length;
    window.phCur = ((i % n) + n) % n;
    views.forEach(function (v, k) { v.classList.toggle('a', k === window.phCur); });
    dots.forEach(function (d, k) { d.classList.toggle('a', k === window.phCur); });
  };

  /* Scroll-drevet galleri: billedet sidder sticky, og mens købskolonnen ruller forbi,
     skifter visningen gennem billederne. Aktiverer sig SELV først når produktet har
     mere end et billede — med et foto er der intet at bladre i, og så ville et
     scroll-lyt bare koste ydelse. Pile, prikker og farvevælger fungerer uændret;
     et manuelt klik sætter styringen på pause resten af besøget, så den ikke
     river billedet tilbage under fingeren på brugeren. */
  (function () {
    var wrap = $('.ph-img-wrap');
    var views = $$('.ph-view:not(.ph-farve)');
    if (!wrap || views.length < 2) return;
    if (window.matchMedia('(max-width: 1024px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var manuel = false;
    $$('.ph-arrow, .ph-dot').forEach(function (el) {
      el.addEventListener('click', function () { manuel = true; });
    });

    var ticking = false;
    function opdater() {
      ticking = false;
      if (manuel) return;
      if ($('.ph-farve') && $('.ph-farve').classList.contains('a')) return;
      var hero = $('#prodHero'); if (!hero) return;
      var r = hero.getBoundingClientRect();
      /* Hvor langt er vi gennem sektionen, 0→1 */
      var rejse = r.height - window.innerHeight;
      if (rejse <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / rejse));
      var i = Math.min(views.length - 1, Math.floor(p * views.length));
      if (i !== window.phCur) window.phGo(i);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(opdater); }
    }, { passive: true });
    opdater();
  })();

  /* ── PRODUKT: variantvalg (rigtige Shopify-varianter) ──── */
  $$('[data-variant-picker]').forEach(function (list) {
    var input = $('#pustVariantId');
    var rows = $$('.opt-row', list);

    function vaelg(row) {
      if (row.getAttribute('data-available') === 'false') return;
      rows.forEach(function (r) {
        var on = r === row;
        r.classList.toggle('active', on);
        r.setAttribute('aria-checked', on ? 'true' : 'false');
        r.setAttribute('tabindex', on ? '0' : '-1');
      });
      if (input) input.value = row.getAttribute('data-variant-id');
      var price = row.getAttribute('data-price') || '';
      var heroPrice = $('#pustHeroPrice'); if (heroPrice) heroPrice.textContent = price;
      /* Uden pil: den er sit eget element ved siden af etiketten, så den kan
         trække fremad ved hover. Skrev vi den ind her, blev elementet slettet. */
      var label = $('#pustBuyLabel'); if (label) label.textContent = 'Køb nu — ' + price;
      var sb = $('#pustStickyPrice'); if (sb) sb.textContent = price;

      /* ”374,50 kr pr. brik” ved siden af den store pris. Tom = en brik. */
      var unit = $('#pustHeroUnit');
      if (unit) {
        var u = row.getAttribute('data-unit') || '';
        unit.textContent = u;
        unit.hidden = !u;
      }

      /* Klarna-raten fulgte IKKE med variantskiftet før (25/8): panelet kunne
         stå med 749 kr og ”146,33 kr/md”, som er raten for 439 kr. Raten er
         regnet i Liquid pr. variant, så der er stadig kun et sted et beløb
         formateres. Tom = uden for Klarnas 350–50.000 kr → skjul linjen frem
         for at love en kredit kunden ikke kan få. */
      var klarna = $('#pustKlarna');
      var rate = row.getAttribute('data-klarna') || '';
      if (klarna) {
        klarna.hidden = !rate;
        var rateEl = $('#psbKlarnaRate', klarna);
        if (rateEl && rate) rateEl.textContent = rate;
      }

      /* Den flydende ”Din kurv” ganger selv op i ører ud fra ET grundtal, som
         Liquid skrev ved render. Uden den her besked blev den stående med den
         forrige variants pris, mens formularen sendte den nye. */
      document.dispatchEvent(new CustomEvent('pust:variant', {
        detail: {
          cents: parseInt(row.getAttribute('data-price-cents'), 10) || 0,
          compare: parseInt(row.getAttribute('data-compare-cents'), 10) || 0
        }
      }));
    }

    rows.forEach(function (row) {
      row.addEventListener('click', function () { vaelg(row); });
      /* Rækkerne er en rigtig radiogruppe: piletaster flytter valget, mellemrum
         og retur vælger. Uden det kan panelets vigtigste kontrol kun betjenes
         med mus. */
      row.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); vaelg(row); return; }
        var frem = e.key === 'ArrowDown' || e.key === 'ArrowRight';
        var tilbage = e.key === 'ArrowUp' || e.key === 'ArrowLeft';
        if (!frem && !tilbage) return;
        e.preventDefault();
        var i = rows.indexOf(row);
        var next = rows[(i + (frem ? 1 : -1) + rows.length) % rows.length];
        if (next) { vaelg(next); next.focus(); }
      });
    });
  });

  /* ── PRODUKT: sticky købsbjælke ────────────────────────── */
  var stickyBar = $('#stickyBar');
  var buyPanel = $('#heroForm');
  if (stickyBar && buyPanel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      stickyBar.classList.toggle('show', !e[0].isIntersecting);
    }, { threshold: 0 }).observe(buyPanel);
  }

  /* ── FOTO-GUIDE (dev): tilføj ?foto=1 til URL'en ───────── */
  if (new URLSearchParams(location.search).has('foto')) {
    $$('[data-foto]').forEach(function (el) {
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      el.style.outline = '2px dashed #E8542F';
      el.style.outlineOffset = '4px';
      var tag = document.createElement('div');
      tag.textContent = el.getAttribute('data-foto');
      tag.style.cssText = 'position:absolute;top:8px;left:8px;right:8px;z-index:950;background:rgba(38,34,28,.92);color:#FF8A5C;font:500 10px/1.7 "Space Mono",monospace;letter-spacing:.06em;padding:8px 12px;border-radius:8px;pointer-events:none;text-transform:uppercase';
      el.appendChild(tag);
    });
  }
})();

/* ── COOKIE-BANNER PÅ DANSK (2026-07-28) ──────────────────────────────
   Shopifys Customer Privacy-banner injiceres på engelsk. Vi oversætter
   kun kendte engelske strenge — dukker banneret op på dansk fra Shopify
   en dag, rører vi ingenting. */
(function () {
  var REVEAL_DELAY = 7000; /* banneret glider først ind efter 7 sek. (ønske: 5–10s). Cookies sættes stadig først ved accept — kun tidspunktet er ændret. */
  var MAP = [
    ['#shopify-pc__banner__btn-accept', 'Accepter'],
    ['#shopify-pc__banner__btn-decline', 'Afvis'],
    ['#shopify-pc__banner__btn-manage-prefs', 'Administrer valg']
  ];
  var BODY_DA = 'Vi og vores partnere, herunder Shopify, bruger cookies til at få butikken til at fungere, huske dine valg og forstå, hvordan siden bruges. Vi sætter dem kun, hvis du accepterer. Læs mere i vores ';

  /* Skjul banneret indtil forsinkelsen er gået, så det ikke rammer besøgende i sekund 0.
     Fejler noget, vises banneret normalt (fail-open) — aldrig skjult for evigt. */
  var st = document.createElement('style');
  st.textContent = '#shopify-pc__banner{transition:opacity .5s ease, transform .5s ease}#shopify-pc__banner.pust-cc-hidden{opacity:0 !important;visibility:hidden !important;transform:translateY(14px) !important;transition:none !important}';
  (document.head || document.documentElement).appendChild(st);

  var shown = false, timer = null;
  function scheduleReveal(el) {
    if (shown) { el.classList.remove('pust-cc-hidden'); return; }
    el.classList.add('pust-cc-hidden');
    if (!timer) timer = setTimeout(function () { shown = true; el.classList.remove('pust-cc-hidden'); }, REVEAL_DELAY);
  }

  function translate(root) {
    var dlg = root.classList.contains('shopify-pc__banner__dialog') ? root : root.querySelector('.shopify-pc__banner__dialog');
    if (!dlg) return false;
    var h = dlg.querySelector('h2');
    if (h && /cookie consent/i.test(h.textContent)) h.textContent = 'Cookies';
    var p = dlg.querySelector('p');
    if (p && /we and our partners/i.test(p.textContent)) {
      var link = p.querySelector('a');
      var href = link ? link.getAttribute('href') : '/pages/privatliv';
      p.textContent = BODY_DA;
      var a = document.createElement('a');
      a.href = href; a.target = '_blank'; a.rel = 'noopener';
      a.textContent = 'privatlivspolitik';
      p.appendChild(a); p.appendChild(document.createTextNode('.'));
    }
    MAP.forEach(function (m) {
      var b = dlg.querySelector(m[0]);
      if (b && /accept|decline|manage/i.test(b.textContent)) b.textContent = m[1];
    });
    return true;
  }
  function tryNow() {
    var el = document.getElementById('shopify-pc__banner');
    if (!el) return false;
    scheduleReveal(el);
    return translate(el);
  }
  if (!tryNow()) {
    var obs = new MutationObserver(function () { if (tryNow()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }
})();

/* ── Ring ved tryk ─────────────────────────────────────────────────────
   Alle knap-effekterne på siden svarer kun på hover, og på telefonen
   findes hover ikke. Ringen svarer på selve trykket, så knappen også
   kvitterer for en finger. Delegeret, så knapper der kommer til senere
   virker uden at binde om.                                              */
(function () {
  var SEL = '.wl-submit, .btn-p, .btn-blk.pr';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;

    /* På gardin-knappen ligger lagene oven på knappens egen flade —
       ringen skal ind i det synlige lag, ellers dækkes den. */
    var host = btn.querySelector('.btn-up') || btn;
    var r = host.getBoundingClientRect();
    if (!r.width) return;

    var d = Math.max(r.width, r.height) * 2.2;
    var s = document.createElement('span');
    s.className = 'pust-rip';
    s.style.width = s.style.height = d + 'px';
    s.style.left = (e.clientX - r.left) + 'px';
    s.style.top = (e.clientY - r.top) + 'px';
    host.appendChild(s);
    setTimeout(function () { s.remove(); }, 640);
  });
})();
